import React from "react";
import { Card, Descriptions, Spin, Typography } from "antd";
import { capitalizeWords } from "../../Util";
import { useProcuringEntity } from "../../hooks/useProcuringEntity";
import { isoDateToHumanReadableDate, getAmount } from "../../Util";
import { LoadingOutlined } from "@ant-design/icons";
const { Title } = Typography;

const CSCContractInfo = ({procuringEntityId}) => {
 
  const { contract, project, loading } = useProcuringEntity(procuringEntityId);
  const antIcon = (
    <LoadingOutlined
      style={{ 
        fontSize: 54,
      }}
      spin
    />
  );

  if (loading) {
    return (
      <Spin
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
        }}
        indicator={antIcon}
      />
    );
  }

  return (
    <Card
      bordered={false}
      style={{
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        borderRadius: "12px",
        backgroundColor: "#ffffff",
        padding: "24px",
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start'}}>
      <Title
        level={4}
        style={{
          marginBottom: 24,
          color: "#0f6788",
          textTransform: "uppercase",
          fontWeight: "bold",
        }}
      >
        CSC Contract Information
      </Title>
      </div>
      <Descriptions
        bordered
        column={1}
        layout="horizontal"
        size="large"
        labelStyle={{
          fontWeight: "bold",
          color: "#0f6788",
          textTransform: "uppercase",
        }}
        contentStyle={{
          fontSize: "16px",
          color: "#595959",
        }}
      >
        <Descriptions.Item label="Project Name">
          {project?.name}
        </Descriptions.Item>
        <Descriptions.Item label="Contract Name">
          {contract?.contract_name || '--//--'}
        </Descriptions.Item>
        <Descriptions.Item label="Contract Number">
          {contract?.contract_no}
        </Descriptions.Item>
        <Descriptions.Item label="Client Name">
          {capitalizeWords(contract?.client?.name || '-')}
        </Descriptions.Item>
        <Descriptions.Item label="Consultant/Consortium Name">
          {contract?.consortium_name || '--//--'}
        </Descriptions.Item>
        <Descriptions.Item label="Consultant Contact">
          {contract?.consultant_contact || "--//--"}
        </Descriptions.Item>
        <Descriptions.Item label="Original Contract Sum">
          { getAmount(typeof contract?.original_contract_sum === 'string' 
              ? JSON.parse(contract?.original_contract_sum) 
              : contract?.original_contract_sum) }
        </Descriptions.Item>
        <Descriptions.Item label="Revised Contract Sum">
          {getAmount(typeof contract?.revised_contract_sum === 'string' 
              ? JSON.parse(contract?.revised_contract_sum) 
              : contract?.revised_contract_sum)} 
        </Descriptions.Item>
        <Descriptions.Item label="Contract Duration">
          {`${contract?.specify_contract_duration}  ${contract?.contract_duration} ` || '--//--'}
        </Descriptions.Item>
        <Descriptions.Item label="Commencement Date of Contract">
          {isoDateToHumanReadableDate(contract?.commencement_date) || '--//--'}
        </Descriptions.Item>
        <Descriptions.Item label="Addendum Signing Date">
          {isoDateToHumanReadableDate(contract?.addendum_signing_date) || '--//--'}
        </Descriptions.Item>
        <Descriptions.Item label="End Date of Contract">
          {isoDateToHumanReadableDate(contract?.end_date_of_contract) || '--//--'}
        </Descriptions.Item>
      </Descriptions>
    </Card>
  );
};

export default CSCContractInfo;
